import eventBus from '../event-bus/event-bus';
import { setData, setInit } from '../store/store';
const resetForm = ({ detail: { id } }) => {
	eventBus.$emit('reset-form', { id });
};
const initForm = ({ detail: { id } }) => {
	setInit(true)
	eventBus.$emit('init-form', { id });
};
export const setPayload = event => {
	setData(event.detail);
	eventBus.$emit('set-payload', event.detail);
};
window.addEventListener('call-request-init-form', initForm);
window.addEventListener('call-request-reset-form', resetForm);
